import { defineMessages } from 'react-intl'

export default defineMessages({
  'AssetMigrate.headerText': {
    id: 'headerText',
    defaultMessage: 'Push Your Fields to the Next Season',
  },
  'AssetMigrate.farmToTransfer': {
    id: 'farmToTransfer',
    defaultMessage: 'Which farm would you like to push to the next season',
  },
  'AssetMigrate.seasonFrom': {
    id: 'seasonFrom',
    defaultMessage: `Which season's data would you like to transfer`,
  },
  'AssetMigrate.seasonTo': {
    id: 'seasonTo',
    defaultMessage: `Which season would you like to push your data to`,
  },
  'AssetMigrate.selectFields': {
    id: 'selectFields',
    defaultMessage: 'Select Fields to Push to the Next Season',
  },
  'AssetMigrate.selectBoxes': {
    id: 'selectBoxes',
    defaultMessage: '(Select all Boxes that Apply)',
  },
})
